import React, { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link } from "react-router-dom";

import { getLastFileDetails } from "../../network/cipAPI";

import RA_XLSFileUpload from "../../FileUpload/raXLSFileUpload";
import Stepper1 from "../../components/Stepper";
import Header from "../../components/Header";
import PageLoading from "../../components/PageLoading";
import DupontButton from "../../components/DupontButton";

import {
  getFormattedDate,
  extractPlantId,
  getSelectedPlantTrainInfo,
} from "../../utils/Utils";
import { ValueStrings } from "../../utils/constantsString";

import "../../styles/vendors/style";

import {
  storeReplacementThreshold,
  updateSelectedTrain,
  storePlantDetails,
  storeUnits,
  storeApp,
} from "../../Store/TemplateStore/template.action";
import { useTranslation } from "react-i18next";
import { Language_Currency_Mapping } from "../home/Settings/settingsOptions.config";
import RoAdvisorHome from "../home";
import "./index.scss";
import moment from "moment";
import { API_URLS } from "../../network/appUrls";

const steps = (t) => [
  t("stepper.performanceData"),
  t("stepper.identifyForecast"),
];
const LifetimeAdvisorHome = (props) => {
  const { t, i18n } = useTranslation();
  const xlmRef = useRef(null);

  const [activeStep, setActiveStep] = useState(0);
  const [isBackClicked, setIsBackClicked] = useState(false);
  const [isNextClicked, setIsNextClicked] = useState(false);
  const [disableNextButton, setDisableNextButton] = useState(false);
  const [previousPredictionResult, setPreviousPredictionResult] = useState();
  const [previousForecastWindow, setPreviousForecastWindow] = useState();
  const {
    token,
    userName,
    plantData,
    selTrain: selectedTrain,
  } = useSelector((state) => state);

  const renamingText =
    activeStep === 1 ? t("appHome.roAdvisor") : t("ValueStrings.next");
  const handleNext = () => {
    setIsBackClicked(false);
    setIsNextClicked(true);
    if (xlmRef && xlmRef.current && (activeStep === 0 || activeStep === 1)) {
      xlmRef.current.onNextClicked();
      if (activeStep === 1) {
        setActiveStep(activeStep + 1);
      }
    } else {
      setActiveStep(activeStep + 1);
    }
  };

  const [isFirstTimeLoad, setIsFirstTimeLoad] = useState(false);
  const [fileDetailsLoaded, setFileDetailsLoaded] = useState(false);

  const handleBack = () => {
    setIsBackClicked(true);
    setIsNextClicked(false);
    if (activeStep - 1 >= 0) setActiveStep(activeStep - 1);
  };
  //const isLocalhost = window.location.hostname === "localhost";
  //const basePath = isLocalhost ? "/" : "/roadvisor/";
  const basePath = API_URLS.basePath;
  const plantId = extractPlantId();

  const dispatch = useDispatch();

  useEffect(() => {
    if (token) {
      dispatch(storeApp("ra"));
      getLastFileDetail();
    }
  }, [token]);

  const getLastFileDetail = async () => {
    try {
      let trainToUse =
        selectedTrain !== undefined && selectedTrain !== null
          ? selectedTrain
          : getSelectedPlantTrainInfo(plantData, plantId);
      dispatch(updateSelectedTrain(trainToUse));
      const fileDetails = await getLastFileDetails(trainToUse);
      if (fileDetails && fileDetails?.data) {
        setIsFirstTimeLoad(true);
        const data = fileDetails.data;
        const {
          modeling: previous_data = null,
          forecast_window: previous_forecast_window = null,
        } = data?.previous_ra_prediction || {};
        setPreviousPredictionResult(previous_data);
        setPreviousForecastWindow(previous_forecast_window);
        const plantInformation = {
          plantLocation: `${
            data?.city ? ` ${data?.city}, ${data?.country}` : `${data?.country}`
          }`,
          plantName: data?.name,
          water_type: data?.water_type,
          num_trains: fileDetails.data?.num_trains,
          tol_num_elements: data?.tol_num_elements,
          is_dupont_element: data?.is_dupont_element,
          sel_train: data?.sel_train,
          sel_pass: data?.sel_pass,
          sel_stage: data?.sel_stage,
          sel_pressure_vessels: data?.sel_pressure_vessels,
          sel_element_involved: data?.sel_element_involved,
          dataset_name: `${userName}_${data.name}_${
            data?.water_type
          }_${getFormattedDate(data?.file?.min_date)} to ${getFormattedDate(
            data?.file?.max_date
          )}`,
          sel_element_type: data?.sel_element_type,
          installation_date: data?.installation_date
            ? moment(data?.installation_date).format(
                ValueStrings.installationDateFormat
              )
            : "",
          is_dupont_element: data?.is_dupont_element ? "Yes" : "No",
        };
        dispatch(storePlantDetails(plantInformation));

        const settings = data?.setting;
        const unitInformation = {
          flux: settings?.plant_name,
          temperature: settings?.temperature,
          permeate_quality: settings?.permeate_quality,
          feed_quality: settings?.feed_quality,
          pressure: settings?.pressure,
          flow: settings?.flow,
          flux: settings?.flux,
          volume: settings?.volume,
          mass: settings?.mass,
          currency:
            settings?.currency ||
            parseFloat(Language_Currency_Mapping(i18n.language).currency),
          conversion_rate:
            settings?.conversion_rate ||
            parseFloat(
              Language_Currency_Mapping(i18n.language).conversion_rate
            ),
          feed_water_permeate_factor: settings?.feed_water_permeate_factor,
          feed_water_factor: settings?.feed_water_factor,
        };
        dispatch(storeUnits(unitInformation));

        const threshold = data?.threshold;
        const thresholdInformation = {
          max_feed_pressure: threshold?.max_feed_pressure,
          max_permeate_quality: threshold?.max_permeate_quality,
          std_warranty_period: threshold?.std_warranty_period,
          startup_pressure_drop: threshold?.startup_pressure_drop,
          designed_permeate_flow: threshold?.designed_permeate_flow,
          std_membrane_age: threshold?.std_membrane_age,
          max_pressure_drop: threshold?.max_pressure_drop,
          min_permeate_flow: threshold?.min_permeate_flow,
          forecast_window: threshold?.forecast_window,
        };
        dispatch(storeReplacementThreshold(thresholdInformation));
        setTimeout(() => {
          setIsFirstTimeLoad(false);
        }, 1000);
      }
    } catch (err) {
      console.log("Error " + err);
    } finally {
      setFileDetailsLoaded(true);
    }
  };

  return (
    <>
      {activeStep !== 2 && (
        <div className="container-main">
          <Header activeStep={activeStep} />
          {/* {activeStep === 0 && (
          <div>
            <Welcome
              message={t("welcomeString.replacementAdvisorIntroduction")}
            ></Welcome>
          </div>
        )} */}
          <div className="main-container footer-exclude">
            <Stepper1
              activeStep={activeStep}
              setActiveStep={setActiveStep}
              handleBack={handleBack}
              handleNext={handleNext}
              steps={steps}
              renamingText={renamingText}
              disableNextButton={disableNextButton}
            />
            {fileDetailsLoaded ? (
              <div>
                <RA_XLSFileUpload
                  ref={xlmRef}
                  activeStep={activeStep}
                  setActiveStep={setActiveStep}
                  previousForecastWindow={previousForecastWindow}
                  previousPredictionResult={previousPredictionResult}
                  isFirstTimeLoad={isFirstTimeLoad}
                  isBackClicked={isBackClicked}
                  setIsBackClicked={setIsBackClicked}
                  isNextClicked={isNextClicked}
                  setDisableNextButton={setDisableNextButton}
                />
              </div>
            ) : (
              <PageLoading customHeight={"350px"} />
            )}
          </div>

          <div className="footer">
            <div className="footer-container">
              <div className="button">
                <DupontButton
                  type="tertiary"
                  onClick={handleBack}
                  // disabled={activeStep === 0}
                >
                  {activeStep === 0 ? (
                    <Link
                      to={`${basePath}Home?plantId=${plantId}`}
                      className="dupont-btn__tertiary--primary "
                    >
                      &lt; {t("ValueStrings.back")}
                    </Link>
                  ) : (
                    ` < ${t("ValueStrings.back")}`
                  )}
                </DupontButton>
                <DupontButton
                  type="tertiary"
                  onClick={handleNext}
                  disabled={activeStep === 1 && disableNextButton}
                >
                  {renamingText} &gt;
                </DupontButton>
              </div>
            </div>
          </div>
        </div>
      )}
      {activeStep === 2 && <RoAdvisorHome />}
    </>
  );
};

export default LifetimeAdvisorHome;
